import { render, staticRenderFns } from "./prospectosDetalles.vue?vue&type=template&id=041e3206&"
import script from "./prospectosDetalles.vue?vue&type=script&lang=js&"
export * from "./prospectosDetalles.vue?vue&type=script&lang=js&"
import style0 from "./prospectosDetalles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports